module.exports = __webpack_public_path__ + "static/media/stop-17.8cb11198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-17.svg
// module id = 1362
// module chunks = 0